import { NavRow } from "@/components/ui/nav-row";
import { cn } from "@/lib/utils";

export function NavItem({
  icon: Icon,
  label,
  badge,
  shortcut,
  isActive,
  onClick,
}: {
  icon: React.ElementType;
  label: string;
  badge?: number;
  shortcut?: string;
  isActive?: boolean;
  onClick?: () => void;
}) {
  return (
    <NavRow
      isSelected={isActive}
      onClick={onClick}
      className="hover:bg-foreground/[0.025]"
    >
      <Icon size={14} className="shrink-0 text-muted-foreground" />
      <span className={cn("min-w-0 flex-1 truncate text-muted-foreground")}>
        {label}
      </span>
      {badge != null && badge > 0 && (
        <span className="inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-primary px-1 text-[10px] font-semibold text-primary-foreground">
          {badge > 99 ? "99+" : badge}
        </span>
      )}
      {shortcut && (
        <span className="rounded border border-border px-1 text-[10px] text-muted-foreground/50">
          {shortcut}
        </span>
      )}
    </NavRow>
  );
}
